import React from "react";

export const Error404 = () => {
  return (
    <div className="d-flex flex-column justify-contnet-center align-items-center gap-4">
      <h1 className="m-0">Error404</h1>
      <p className="m-0">Page Not Found</p>
    </div>
  );
};
